<template>
  <table class="table align-items-center mb-0">
    <thead>
      <tr>
        <th class="text-sm">Port</th>
        <th class="text-sm">TX Power (dBm)</th>
        <th class="text-sm">Vendor Name</th>
        <th class="text-sm">Vendor SN</th>
        <th class="text-sm">Bias Current (mA)</th>
        <th class="text-sm">Voltage (V)</th>
        <th class="text-sm">Temperature (°C)</th>
        <th class="text-sm">Wavelength (nm)</th>
        <th class="text-sm">Detail</th>
      </tr>
    </thead>
    <tbody>
      <template v-if="loading">
        <tr>
          <td colspan="9">
            <Skalaton />
          </td>
        </tr>
      </template>
      <template v-else-if="getFilteredPonPorts().length > 0">
        <tr
          v-for="port in getFilteredPonPorts()"
          :key="port['Port ID']"
        >
          <td class="text-sm">{{ port['Port ID'] }}</td>
          <td class="text-sm">{{ port['Transmit Power(dBm)'] }}</td>
          <td class="text-sm">{{ port['Vendor Name'] }}</td>
          <td class="text-sm">{{ port['Vendor SN'] }}</td>
          <td class="text-sm">{{ port['Bias Current(mA)'] }}</td>
          <td class="text-sm">{{ port['Voltage(V)'] }}</td>
          <td class="text-sm">{{ port['Temperature(°C)'] }}</td>
          <td class="text-sm">{{ port['Wavelength(nm)'] }}</td>
          <td class="text-sm">{{ port['Detail'] }}</td>
        </tr>
      </template>
      <template v-else>
        <tr>
          <td colspan="9" class="text-center">
            <Skalaton />
            <!-- No PON port data available -->
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
import Skalaton from '@/components/Skalaton.vue';

export default {
  name: 'VsolPonTable',
  components: {
    Skalaton
  },
  props: {
    vsolPonInfo: Object,
    vsolBasicInfo: Object,
    loading: Boolean
  },
  methods: {
    getFilteredPonPorts() {
      if (!this.vsolPonInfo?.poninfo?.optical_transceiver) {
        return [];
      }
      
      const allPorts = this.vsolPonInfo.poninfo.optical_transceiver;
      
      // If we have detected ports from basic info, filter by them
      if (this.vsolBasicInfo?.systeminfo?.detected_ports) {
        return allPorts.filter(port => 
          this.vsolBasicInfo.systeminfo.detected_ports.includes(port['Port ID'])
        );
      }
      
      return allPorts;
    }
  }
}
</script>